module.exports = __webpack_public_path__ + "static/img/zf1-2.c8051ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zf1-2.png
// module id = 715
// module chunks = 0